const faqCptInit = (block) => {
    const faqs = block ? block[0].querySelectorAll(".bn-faq-cpt") : document.querySelectorAll(".bn-faq-cpt");

    if (faqs && faqs.length) {
        faqs.forEach((faq) => {
            [...faq.querySelectorAll(".bn-faq-cpt__tab")].forEach((el) => {
                const answer = el.querySelector(".bn-faq-cpt__tab--answer");
                const content = answer.querySelector(".bn-faq-cpt__tab--text");

                el.addEventListener("click", (e) => {
                    const isOpen = el.classList.contains("--open");

                    if (!isOpen) {
                        el.classList.add("--open");
                        answer.style.height = content.offsetHeight + "px";
                    } else {
                        el.classList.remove("--open");
                        answer.style.height = "0";
                    }
                });
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        faqCptInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/faq-cpt', faqCptInit);
});